export const HOME_MATCH_DEFAULT_PRICE_UPPER = 800_000;
export const HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX = 4_500_000;

/** HomeMatch Basic consent starts off everywhere (opt-in). */
export const DEFAULT_HOME_MATCH_BASIC_CONSENT = false;
export const HOME_MATCH_DEFAULT_PRICE_UPPER = 800_000;
export const HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX = 4_500_000;

/** HomeMatch Basic consent starts off everywhere (opt-in). */
export const DEFAULT_HOME_MATCH_BASIC_CONSENT = false;
